import { FileUpload } from '@consigli/facade';
import { ExtendedFile, useGetPackagesByTypeQuery } from '@consigli/hooks';
import { DocumentPackageType } from '@consigli/types';
import { Dispatch, SetStateAction } from 'react';
import { useFormContext } from 'react-hook-form';
import { useTranslation } from 'react-i18next';

import { IterationName } from '@/features/package-creation/components/iteration-name';
import { SelectLanguage } from '@/features/package-creation/components/select-language';
import { useFetchValidateName } from '@/features/package-creation/components/user-input';

interface LuminaireUploadFormProps {
  onSubmit: () => void;
  projectId: number;
  type: DocumentPackageType;
  children: React.ReactNode;
  setSelectedFiles: Dispatch<SetStateAction<ExtendedFile[]>>;
  selectedFiles: Array<ExtendedFile>;
}

export function LuminaireUploadForm({
  children,
  onSubmit,
  projectId,
  type,
  setSelectedFiles,
  selectedFiles,
}: LuminaireUploadFormProps) {
  const { t } = useTranslation();
  const { handleSubmit } = useFormContext();

  const { validateName } = useFetchValidateName(useGetPackagesByTypeQuery, {
    projectId,
    type,
  });

  return (
    <form onSubmit={handleSubmit(onSubmit)} className="w-full">
      <div className="flex flex-col" translate="no">
        <IterationName
          validateName={validateName}
          label={t('package-creation.analysis-name')}
          errorMessage={`${t('package-creation.analysis-name-empty')}*`}
        />
      </div>
      <SelectLanguage />
      <FileUpload
        setFiles={setSelectedFiles}
        files={selectedFiles}
        dropAreaLabel={t('document-upload.drag-n-drop-here')}
        fileButtonLabel={t('document-upload.browse-files')}
        uploadListLabel={t('file')}
        zeroByteFilesMessage={t('document-upload.file-zero-bytes')}
        dropAreaClassName="mt-2 h-48 w-full"
        showMessagePanel={true}
      />
      {children}
    </form>
  );
}
